export default {
  reducer_set_banner(state, data) {
    if (data) {
      state.banner.data = data;
    }

    return {
      ...state,
    };
  },
  reducer_set_banner_as_dissmissed(state, data) {
    if (data) {
      state.banner.dissmissed.push(data.dissmissed);
    }

    return {
      ...state,
      banner: {
        dissmissed: state.banner.dissmissed,
      },
    };
  },
};
